var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('div',{staticClass:"logo-empresa"},[_c('img',{attrs:{"src":_vm.owner.image_url}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }